import React from 'react';
import SubfoldersIcon from '../../Icons/Subfolders';
import DeviationDumbView from '../../DeviationViews/Dumbo';
import s from '../FolderCard.scss';
var LIST_VIEW_PREVIEW_WIDTH = 230;
var LIST_VIEW_PREVIEW_HEIGHT = 129;
var FolderCardContent = function (_a) {
    var className = _a.className, thumb = _a.folder.thumb, subfolders = _a.subfolders, width = _a.width, height = _a.height;
    var hasSubfolders = subfolders && subfolders.length > 0;
    if (!width || !height) {
        return null;
    }
    if (!thumb) {
        return React.createElement("div", { className: s['preview'], style: { width: width, height: height } });
    }
    return (React.createElement("div", { className: className },
        hasSubfolders && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['subfolders-icon-underlay'] }),
            React.createElement(SubfoldersIcon, { className: s['subfolders-icon'] }))),
        React.createElement(DeviationDumbView, { className: s['preview'], width: width || LIST_VIEW_PREVIEW_WIDTH, height: height || LIST_VIEW_PREVIEW_HEIGHT, deviation: thumb })));
};
export default FolderCardContent;
//# sourceMappingURL=FolderCardContent.js.map